export default [
    function () {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                location: '=',
            },
            controllerAs: 'ctrl',
            controller: [function () { }],
            template: `
                <div class="location-message">
                    <div class="circle">
                        <i class="material-icons md-24">location_on</i>
                    </div>
                    <div class="location-details">
                        <div class="description">{{ ctrl.location.description }}</div>
                        <div class="details" ng-if="ctrl.location.address">{{ ctrl.location.address }}</div>
                        <div class="details" ng-if="!ctrl.location.address">{{ ctrl.location.lat }}, {{ ctrl.location.lon }}</div>
                    </div>
                </div>
            `,
        };
    },
];
